import React from 'react';

export default class ServicePartSectionPanelContent extends React.Component {

    handleSelectPart(partId, event) {
        this.props.handleSelectPart(partId, event);
    }

    isDisabledInput(partId) {
        return ((this.props.selectedParts.indexOf(partId) == -1) && (this.props.max > 0) && (this.props.max == this.props.selectedParts.length));
    }

    isRequiredSection(section) {
        return (section.min >= 1 && section.max == 1);
    }

    render() {
        return <div>
            {this.renderSection(this.props.partsSection)}
        </div>;
    }

    renderSection(section) {

        return section.service_part_options.map((part) => {
            const price = <span>{parseFloat(part.price_cents / 100).toFixed(2)}&nbsp;€</span>;

            if (part.available) {
                return (
                    <div className="service-part" key={part.id}>
                        {this.isRequiredSection(section) ? this.renderRadioButton(part, section.id) : this.renderCheckbox(part)}
                        <div className="price">+ {price}</div>
                    </div>
                )
            }
        });
    }

    renderCheckbox(part) {
        return (
            <div className="checkbox">
                <label htmlFor={part.id}>
                    <input type="checkbox" id={part.id}
                           disabled={this.isDisabledInput(part.id)}
                           onChange={this.handleSelectPart.bind(this, part.id)}/>
                    {part.name}
                    <div className="part-description">{part.description}</div>
                </label>
            </div>
        );
    }

    renderRadioButton(part, name) {
        return (
            <div className="radio">
                <label htmlFor={part.id}>
                    <input type="radio" name={name} id={part.id}
                           onChange={this.handleSelectPart.bind(this, part.id)}/>
                    {part.name}
                    <div className="part-description">{part.description}</div>
                </label>
            </div>
        );
    }
}
